export default __webpack_public_path__ + "static/media/NGHS_Logo.27a71291.png";